export default __webpack_public_path__ + "static/media/AR-11.a63bc51e.jpg";